/**
 * @desc coupon mutations
 */

import {types} from '../constants/types'

const {UPDATE_SUBIMT_COUPON, UPDATE_COUPON_LIST, RESET_COUPON_LIST, RESET_PRODUCT_AVALIABLE_COUPON_LIST, UPDATE_PRODUCT_RESET_COUPON_LIST, UPDATE_RECEIVED_COUPON_STATE, COUNT_MAX_COUPON_INFO} = types

export default {
  // 选择优惠券信息
  [UPDATE_SUBIMT_COUPON](state, {couponInfo}) {
    state.couponInfo = couponInfo
  },
  [UPDATE_COUPON_LIST](state, {data}) {
    // update
    function generate(item) {
      if (!item.isSelected) {
        item.isSelected = false
      }
      if (item.isUsable === '1') {
        state.couponList.usableList.push(item)
      } else {
        state.couponList.unusableList.push(item)
      }
    }

    state.couponList.count = data.datas.length
    data.datas.forEach(item => generate(item))
  },
  // 默认最大优惠券选中
  [COUNT_MAX_COUPON_INFO](state) {
    let usableList = state.couponList.usableList
    if (usableList.length > 0) {
      let maxDiscount = -1
      let maxCouponInfo
      let maxCouponInfoIndex
      usableList.forEach((item, index) => {
        if (maxDiscount < Number(item.discountFee, 10)) {
          maxDiscount = Number(item.discountFee, 10)
          maxCouponInfo = item
          maxCouponInfoIndex = index
        }
      })
      usableList[maxCouponInfoIndex].isSelected = true
      state.couponInfo = maxCouponInfo
    }
  },
  // 更新可领取优惠券信息
  [UPDATE_RECEIVED_COUPON_STATE](state, {index, status}) {
    // update
    let {receiveList, receiveErrorLength, receiveSuccessLength} = state.productAvaliableCouponList
    receiveList[index].isReceived = status // 已经被领取(成功或失败)
    if (status === 'error') {
      receiveErrorLength = receiveErrorLength + 1  // 领取失败条数
    } else if (status === 'success') {
      receiveSuccessLength = receiveSuccessLength + 1
    }
    state.productAvaliableCouponList = Object.assign({}, {
      receiveList,
      receiveErrorLength,
      receiveSuccessLength
    })
  },
  // reset
  [RESET_COUPON_LIST](state) {
    state.couponList = {
      count: 0,
      usableList: [],
      unusableList: []
    }
  },
  // 当前可以领取的优惠券
  [UPDATE_PRODUCT_RESET_COUPON_LIST](state, data) {
    /**
     * 用户未领取的优惠券
     * useDatas用户已领取的优惠券
     * couponMode 优惠模式：Cash现金券， Discount折扣券，Random随机券
     */
    let receive = []
    data && data.forEach((item) => {
      item.dataList.forEach(((val) => {
        if (parseInt(val.reveiveRate) < 100 && val.canReceive === '1') { // 领完的就不展示
          if (!val.isReceived) { // 等待领取
            val.isReceived = 'ing'
          }
          val.typeCode = item.typeCode
          receive.push(val)
        }
      }))
    })
    state.productAvaliableCouponList.receiveList = receive
  },
  // 重置商品可领取优惠券
  [RESET_PRODUCT_AVALIABLE_COUPON_LIST](state) {
    state.productAvaliableCouponList = {
      receiveList: [] // 当前商品用户未领取优惠券
      , receiveErrorLength: 0 // 领取失败条数
      , receiveSuccessLength: 0 // 领取成功条数
    }
  }
}
